import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Writes an edit into the in-memory settings lookup. */
export const applyEdit = store.effects.create(
  (feature: Plugin['feature'], settingsStorage: Plugin['settingsStorage']) =>
    feature.actions.edit.relay((forwardTo, { id, edit }) =>
      rxjs.of(
        forwardTo(settingsStorage.actions.putInLookup, {
          input: { key: id, value: edit },
        }),
      ),
    ).asObservable,
)
